import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import service from './service'
import i18n from './i18n'
import 'normalize.css/normalize.css'
import './assets/iconfont/iconfont.css'

Vue.use(service)

Vue.prototype.$lang = lang => {
  store.dispatch("lang", lang)
  i18n.locale = lang
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
